var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/text/text.tsx";
const _excluded = ["align", "className", "direction", "family", "size", "tag", "theme", "tracking", "transform", "truncate", "weight"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import classNames from 'classnames';
import React from 'react';
const themes = {
  default: 'text-gray-900 dark:text-gray-100',
  danger: 'text-danger-600',
  primary: 'text-primary-600 dark:text-primary-400',
  muted: 'text-gray-500 dark:text-gray-300',
  subtle: 'text-gray-400 dark:text-gray-500',
  success: 'text-success-600',
  inherit: 'text-inherit',
  white: 'text-white'
};
const weights = {
  normal: 'font-normal',
  medium: 'font-medium',
  semibold: 'font-semibold',
  bold: 'font-bold'
};
const sizes = {
  xs: 'text-xs',
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-lg',
  xl: 'text-xl',
  '2xl': 'text-2xl',
  '3xl': 'text-3xl'
};
const alignments = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right'
};
const trackingSizes = {
  normal: 'tracking-normal',
  wide: 'tracking-wide'
};
const transformProperties = {
  normal: 'normal-case',
  uppercase: 'uppercase'
};
const families = {
  sans: 'font-sans',
  mono: 'font-mono'
};
/** UI-friendly text container with dark mode support. */
const Text = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      align,
      className,
      direction,
      family = 'sans',
      size = 'md',
      tag = 'p',
      theme = 'default',
      tracking = 'normal',
      transform = 'normal',
      truncate = false,
      weight = 'normal'
    } = props,
    filteredProps = _objectWithoutProperties(props, _excluded);
  const Comp = tag;
  const alignmentClass = typeof align === 'string' ? alignments[align] : '';
  return /*#__PURE__*/React.createElement(Comp, _extends({}, filteredProps, {
    ref: ref,
    style: {
      textDecoration: tag === 'abbr' ? 'underline dotted' : undefined,
      direction
    },
    className: classNames({
      'cursor-default': tag === 'abbr',
      truncate: truncate,
      [sizes[size]]: true,
      [themes[theme]]: true,
      [weights[weight]]: true,
      [trackingSizes[tracking]]: true,
      [families[family]]: true,
      [alignmentClass]: typeof align !== 'undefined',
      [transformProperties[transform]]: typeof transform !== 'undefined'
    }, className),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 114,
      columnNumber: 7
    }
  }));
});
export default Text;